export default __webpack_public_path__ + "static/media/twitter-icon-orange.8c5c18d5.svg";